import { useTranslation } from 'react-i18next';

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section className="relative min-h-[60vh] overflow-hidden flex items-center">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Hong%20Kong%20financial%20district%20skyline%20at%20golden%20hour%2C%20luxury%20skyscrapers%20reflecting%20in%20water%2C%20prestigious%20banking%20architecture%2C%20warm%20amber%20golden%20light%20casting%20over%20modern%20corporate%20buildings%2C%20sophisticated%20financial%20hub%20atmosphere%20with%20elegant%20golden%20tones%2C%20premium%20wealth%20management%20aesthetic&width=1920&height=900&seq=license-hero-bg-001&orientation=landscape')`
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-amber-900/85 via-amber-800/70 to-yellow-900/60"></div>
      </div>

      {/* Decorative geometric elements */}
      <div className="absolute top-16 right-24 w-40 h-40 border border-amber-400/25 rounded-full animate-pulse"></div>
      <div className="absolute bottom-16 right-48 w-24 h-24 border border-yellow-300/20 rounded-full animate-ping" style={{ animationDuration: '3s' }}></div>
      <div className="absolute top-1/3 right-16 w-16 h-16 border border-amber-300/30 rotate-45"></div>

      <div className="relative z-10 w-full container mx-auto px-6 py-24">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2 bg-amber-400/20 border border-amber-400/40 rounded-full px-5 py-2 mb-8">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-verified-badge-fill text-amber-300 text-sm"></i>
            </div>
            <span className="text-amber-200 text-sm font-semibold tracking-widest uppercase">
              {t('license.hero.badge')}
            </span>
          </div>

          <h1 className="text-5xl font-bold text-white mb-6 leading-tight">
            {t('license.hero.title')}
          </h1>
          <p className="text-xl text-amber-100 leading-relaxed mb-8 max-w-2xl opacity-90">
            {t('license.hero.subtitle')}
          </p>

          <div className="flex flex-wrap gap-6">
            <div className="flex items-center gap-3 bg-white/10 backdrop-blur-sm rounded-lg px-5 py-3 border border-white/20">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-shield-check-fill text-amber-300 text-xl"></i>
              </div>
              <span className="text-white font-medium">{t('license.hero.badge1')}</span>
            </div>
            <div className="flex items-center gap-3 bg-white/10 backdrop-blur-sm rounded-lg px-5 py-3 border border-white/20">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-medal-fill text-amber-300 text-xl"></i>
              </div>
              <span className="text-white font-medium">{t('license.hero.badge2')}</span>
            </div>
            <div className="flex items-center gap-3 bg-white/10 backdrop-blur-sm rounded-lg px-5 py-3 border border-white/20">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-government-fill text-amber-300 text-xl"></i>
              </div>
              <span className="text-white font-medium">{t('license.hero.badge3')}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
